import { axios } from '@/services/axios';

const createUserProfile = async ({ formData, scope, token }) => {
    const res = await axios.post('/UserProfile', formData, {
        headers: {
            authorization: `Bearer ${token}`,
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default createUserProfile;
